import { combineReducers } from 'redux'

// ACTIONS
export const FETCH = 'company/candidateList/positions/FETCH'
export const FETCH_SUCCESS = 'company/candidateList/positions/FETCH_SUCCESS'

export const UPDATE = 'company/candidateList/positions/UPDATE'
export const UPDATE_SUCCESS = 'company/candidateList/positions/UPDATE_SUCCESS'

export const RESET_ALL = 'company/candidateList/positions/RESET_ALL'

export const TOGGLE_LOADING = 'company/candidateList/positions/TOGGLE_LOADING'
export const TOGGLE_LOADING_DETAIL = 'company/candidateList/positions/TOGGLE_LOADING_DETAIL'
export const TOGGLE_UPDATING = 'company/candidateList/positions/TOGGLE_UPDATING'
export const TOGGLE_NOTICE = 'company/candidateList/positions/TOGGLE_NOTICE'

export const SELECT_POSITION = 'company/candidateList/positions/SELECT_POSITION'
export const UNSELECT_POSITION = 'company/candidateList/positions/UNSELECT_POSITION'

// ACTION CREATORS
export const toggleLoading = loading => ({
  type: TOGGLE_LOADING,
  payload: { loading },
})

export const toggleLoadingDetail = loadingDetail => ({
  type: TOGGLE_LOADING_DETAIL,
  payload: { loadingDetail },
})

export const toggleUpdating = updating => ({
  type: TOGGLE_UPDATING,
  payload: { updating },
})

export const toggleNotice = (showNotice, isDismissed) => ({
  type: TOGGLE_NOTICE,
  meta: { isDismissed },
  payload: { showNotice },
})

export const fetch = (hiring_team_id, params) => ({
  type: FETCH,
  payload: {
    hiring_team_id,
    params: {
      archived: false,
      order_by: 'updated_at',
      order_direction: 'desc',
      items_per_page: defaultPagination.items_per_page,
      ...params,
    },
  },
})

export const fetchSuccess = ({ result, pagination_info }) => ({
  type: FETCH_SUCCESS,
  payload: {
    collection: [...result],
    pagination_info,
  },
})

export const update = (hiring_team_id, positionId, data) => ({
  type: UPDATE,
  payload: {
    hiring_team_id,
    positionId,
    data,
  },
})

export const updateSuccess = ({ result }) => ({
  type: UPDATE_SUCCESS,
  payload: { ...result },
})

export const resetAll = () => ({
  type: RESET_ALL,
})

export const selectPosition = position => ({
  type: SELECT_POSITION,
  payload: { ...position },
})

export const unselectPosition = () => ({
  type: UNSELECT_POSITION,
})

// REDUCERS
const defaultUtils = {
  loading: true,
  loadingDetail: true,
  creating: false,
  updating: false,
  error: null,
  showNotice: false,
}

const utils = (state = defaultUtils, { type, payload }) => {
  switch (type) {
    case TOGGLE_LOADING:
    case TOGGLE_LOADING_DETAIL:
    case TOGGLE_UPDATING:
    case TOGGLE_NOTICE:
      return {
        ...state,
        ...payload,
      }

    case RESET_ALL:
      return defaultUtils

    default:
      return state
  }
}

const collection = (state = [], { type, payload }) => {
  switch (type) {
    case FETCH_SUCCESS:
      return [...payload.collection]

    case UPDATE_SUCCESS:
      return state.map(elem => {
        if (elem.id === payload.id) {
          return {
            ...elem,
            ...payload,
          }
        }
        return elem
      })

    case RESET_ALL:
      return []

    default:
      return state
  }
}

const member = (state = {}, { type }) => {
  switch (type) {
    case RESET_ALL:
      return {}

    default:
      return state
  }
}

const defaultPagination = {
  current_page: 0,
  total_pages: 0,
  items_per_page: 20,
  total_items: 0,
}

const pagination = (state = defaultPagination, { type, payload }) => {
  switch (type) {
    case FETCH_SUCCESS:
      return {
        ...state,
        ...payload.pagination_info,
      }

    case RESET_ALL:
      return defaultPagination

    default:
      return state
  }
}

const fromList = (state = {}, { type, payload }) => {
  switch (type) {
    case SELECT_POSITION:
      return {
        ...state,
        ...payload,
      }

    case UNSELECT_POSITION:
      return {}

    default:
      return state
  }
}

export default combineReducers({
  utils,
  collection,
  member,
  pagination,
  fromList,
})
